import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import appcolors from "../../../constants/Colors";
import { useTranslation } from "react-i18next";
// box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;

const ReportCard = ({ data }) => {
  const { t } = useTranslation(["report"]);
  return (
    <Stack
      p={2}
      direction={"row"}
      alignItems={"center"}
      justifyContent={"space-between"}
      borderRadius={1}
      bgcolor={"primary.main"}
      boxShadow={3}
    >
      <Box>
        <Typography variant={"body1"} fontWeight={500} color={"custom.white"}>
          {t(data?.primary)}
        </Typography>
        {data?.secondary && (
          <Typography
            variant={"body2"}
            fontSize={"0.75rem"}
            color={"custom.white"}
          >
            {t(data?.secondary)}
          </Typography>
        )}
      </Box>
      <Typography
        variant={"h3"}
        fontSize={"1.1rem"}
        fontWeight={800}
        color={"custom.white"}
      >
        {data?.value}
      </Typography>
    </Stack>
  );
};

export default ReportCard;
